import { ICourseListingPage } from "./interfaces";
import { getCoursesByFilter, getCourseWidgets } from "@/helpers/api/service/Course";
import { CourseFilter } from "@/components/CourseWidget/CourseFilter";
import { CourseCardList } from "@/components/CourseWidget/CourseCardList";
import CourseListingSEO from "@/components/Head/course-listing";
import Pagination from "@/components/Pagination";
import { Fragment, useState } from "react";
import dynamic from "next/dynamic";
import { courseNavigationData } from "@/config/navigation";
import { useRouter } from "next/router";
import TopIcon from "@/components/SVG/TopIcon";
import LinkWrapper from "@/components/LinkWrapper";
import FAQ from "@/components/FAQ";
import { GetStaticProps, GetStaticPaths } from "next";
import { isCSRRequest } from "@/utils";
import TopCards from "@/components/TopCards";
import { BACKEND_API, STATIC_CDN_WEB_SVG, VIDEO_CDN } from "@/config/constants";
import StatsV2 from "@/components/Stats/StatsV2";
import SubtlePrism from "@/components/SVG/HeroSection/Abstract/SubtlePrism";
import Results from "@/components/Results/Results";
import MetaSeo from "@/components/Head/Meta";
import CourseWidget from "@/components/CourseWidget";
import CourseCardV2List from "@/components/CourseWidget/CourseCardV2List";
import { PAGE } from "@/config/enums";
import StatsV1 from "@/components/Stats/StatsV1";
import CourseLeadForm from "@/components/Lead/Course";

const HeroSection = dynamic(() => import("@/components/SVG/HeroSection/Course"));
const ViewMore = dynamic(() => import("@/components/ViewMore"));

const CourseListingPage = (props: {
  data: ICourseListingPage;
  categoryWidgets?: any[];
  category: string;
}) => {
  const router = useRouter();

  if (!Object.keys(router.query).length) {
    const data: any[] = props.data.widgets?.map((item) => ({
      courseName: item.title,
      description: item.subtitle,
      displayPrice: item.display_price,
    }));
    return (
      <>
        <CourseListingSEO data={data} title={props.data.title} description={props.data.content?.[0]} />
        <SubtlePrism>
          <section className="body-content flex flex-wrap lg:flex-nowrap gap-4 my-0 py-4">
            <div className="lg:basis-3/5 grow lg:pr-12">
              <h1 className="text-white">{props.data.title}</h1>
              <p className="text-white hidden lg:block">{props.data.content}</p>
            </div>
          </section>
          <div className="lg:h-64"></div>
        </SubtlePrism>
        <div className="card p-2 flex justify-center max-w-[854px] mx-auto mt-8 lg:-mt-64 relative z-30">
          <iframe
            src="https://www.youtube.com/embed/3N1opESiIpk?autoplay=1&loop=1&rel=0&modestbranding=1"
            allow="autoplay; encrypted-media;"
            sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
            allowFullScreen
            title="Course Promo"
            className="w-full h-full mx-auto aspect-video"
          />
        </div>
        <div className="body-content prose-h2:text-center">
          <section>
            <h2>We offer Online Coaching across all Categories</h2>
            <p>Doubtnut provides online coaching classes for students belonging to class 6 to class 12 of all state boards and provides coaching for competitive exams like IIT JEE and NEET.
              Not only this, we&apos;ll help you prepare for Government Exams like NDA and also offer courses for English speaking and English grammar to improve your conversational skills and enhance your grammar proficiency.
            </p>
            <TopCards items={props.data.topCards as any} maxCount={3} />
            <hr className="mb-0" />
          </section>
          {
            !!props.data.widgets.length && <section>
              <h2>Our Best Sellers</h2>
              <CourseCardList data={props.data.widgets} />
            </section>
          }
          <TopCards title="Our Offerings" items={props.data.offerings} />
          <section>
            <StatsV2 items={props.data.stats} />
          </section>
          <section>
            <h2>Meet Our Toopers</h2>
            <Results items={props.data.results} />
          </section>
          <hr />
          <section>
            <FAQ data={props.data.faq} />
          </section>
        </div>
      </>
    );
  }


  if (!props.data?.widgets) {
    return <></>;
  }

  const [_filtersWidget, ...courseDetails] = props.data.widgets;

  const assortmentHt: { [key: string]: any } = {};
  for (let item of courseDetails) {
    let doesntInclude = !(item?.assortment_id in assortmentHt);
    if (doesntInclude) {
      assortmentHt[item.assortment_id] = {
        courseName: item.title,
        description: item.subtitle || item.title,
        assortmentId: item.assortment_id,
        displayPrice: item.display_price,
      };
    }
  }
  const data = Object.values(assortmentHt);

  //@ts-ignore
  // const subpagesData: any = courseNavigationData.find(x => x.url == router.asPath.split("&")[0])?.content || courseNavigationData.find(x => !x.url)?.content?.find((x: any) => x.url == router.asPath)?.content;
  return (
    <>
      <CourseListingSEO data={data} title={props.data.title} description={props.data.content?.[0]} />
      {
        (props.data.title && !props.categoryWidgets?.length) && (
          <HeroSection entityId={props.data.category}>
            <section className="body-content flex flex-wrap lg:flex-nowrap gap-4 my-0">
              <div className="lg:basis-3/5 grow">
                <h1 className="text-white">{props.data.title}</h1>
                {
                  props.data.content?.map((x, i) => <div className="my-5 text-white" key={i.toString()} dangerouslySetInnerHTML={{ __html: x }}></div>)
                }
              </div>
            </section>
          </HeroSection>
        )
      }
      <div className="body-content flex gap-8">
        <div className="w-full lg:basis-2/3">
          {/*  hero section */}
          {
            !!props.categoryWidgets?.length &&
            <div>
              <section className="space-y-6">
                <h1 className="text-3xl sm:text-4xl mt-8">{props.data.title}</h1>

                {
                  props.data.content && <ViewMore content={props.data.content} />
                }
              </section>
            </div>
          }

          {
            !!props.categoryWidgets?.length &&
            <CourseWidget category={props.category} className="px-2 lg:px-0" items={props.categoryWidgets?.slice(props.categoryWidgets[0].props.iframeSrc ? 1 : 0, props.categoryWidgets?.length)}/>
          }

          {/* {
            (!props.categoryWidgets?.length && subpagesData?.length > 1) && <section>
              <h2>Filter by Class</h2>
              <div className="grid grid-cols-3 lg:grid-cols-5 grid-flow-row gap-4">
                {
                  subpagesData.map((x: any, i: number) => (
                    <LinkWrapper key={i.toString()} href={x.url} className="no-underline">
                      <TopIcon text={x.name} className={`bg-${x.name.toLowerCase().replace(/ /g, "-")}`} />
                    </LinkWrapper>
                  ))
                }
              </div>
              <hr />
            </section>

          } */}

          {
            !props.categoryWidgets?.length &&
            <section>
              {!props.data.title && <h1 className="text-center">Apne liye best batch chuno</h1>}
              {/* <CourseFilter data={filtersWidget} /> */}
              {/* <Pagination totalPage={response.data.totalPage} /> */}
              {/* <CourseCardList data={courseDetails} /> */}
              <CourseCardV2List category={props.data.category?.toLowerCase().split(" ").join("-")} items={courseDetails} />
              {/* <Pagination totalPage={response.data.totalPage} /> */}
            </section>
          }

        </div>
        <div className="flex hidden lg:block lg:basis-1/3 mt-8">
          <CourseLeadForm title="Want more help for NEET"/>
        </div>
      </div>

      {
        !!props.data.offerings?.length &&
        <div className="body-content">
          <hr />
          <h2 className="text-center">Our Offerings</h2>
          <TopCards items={props.data.offerings} />
        </div>
      }

      {
        !!props.data.stats?.length &&
        <div className={`body-fluid py-8 bg-${props.data.category?.split(" ").join("-").toLowerCase() || "cbse-board"}`}>
          <div className="body-content prose-h2:text-4xl lg:prose-h2:text-4xl">
            <section className='text-center'>
              <div className='flex flex-wrap px-6'>
                <h2 className='text-white grow lg:basis-1/3'>
                  Our Achievements
                </h2>
                <div className='lg:basis-2/3 grow flex flex-wrap justify-around'>
                  <StatsV1 stats={props.data.stats} />
                </div>
              </div>
            </section>
          </div>
        </div>
      }

      {
        !!props.data.results?.length &&
        <div className="body-content">
          <hr />
          <h2 className="text-center">Our Toppers</h2>
          <Results items={props.data.results} />
        </div>
      }

      <div className="body-content">
        {
          !!props.data.sections?.length &&
          <>
            <hr />
            <section>
              {
                props.data.sections?.map((x, i) => (
                  <Fragment key={i.toString()}>
                    <h3>{x.title}</h3>
                    {
                      x.content?.map((y, j) => <p key={j.toString()} dangerouslySetInnerHTML={{ __html: y }}></p>)
                    }
                  </Fragment>
                ))
              }
            </section>
          </>
        }
        {
          !!props.data.faq?.length &&
          <>
            <hr />
            <FAQ data={props.data.faq} />
          </>
        }
      </div>
    </>
  );
};

export const getStaticPaths: GetStaticPaths = (ctx) => {
  return {
    paths: [],
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  // if (!isCSRRequest(ctx.req.url) && !(getCourseNavigationUrls().includes(ctx.req.url as string))) {
  //   return { notFound: true };
  // }
  let courseFilter = ctx.params?.courseFilter;

  const query: any = {};
  switch (courseFilter?.[0]) {
    case "exam-class":
      query["Exam"] = courseFilter[1];
      query["Class"] = courseFilter[2];
      break;
    case "exam":
      query["Exam"] = courseFilter[1];
      break;
    case "class":
      query["Class"] = courseFilter[1];
      break;
  }

  const response = await getCoursesByFilter(query as any);

  let categoryWidgets = [];
  let category = "";
  
  const response2 = await getCourseWidgets({
    Exam: query.Exam as string,
    page: PAGE.COURSE
  })
  categoryWidgets = response2.data?.widgets || [];
  category = response2.data?.category || ""

  const index = response2.data?.widgets.findIndex((item:any)=>item.nodeName == "course-list");
  
  if(categoryWidgets[index]){
    categoryWidgets[index].props.items = response.data.widgets;
  }

  return {
    props: {
      data: {
        ...response.data, 
      },
      category,
      categoryWidgets,
      breadcrumbs: response.breadcrumbs || null,
    },
    // 2 hours
    revalidate: 7200,
  };
};

export default CourseListingPage;
